import APPNAMES from '../appNames'
import FIELDS from '../field'
import { familyMemberFields } from '../fieldLists'
import { Config } from '@/types/partnerConfig'
import {
  aboutYouStep,
  summaryStep,
  welcomeStep,
  familyStep,
  eligibilityStep,
} from '../steps'

const premadeConfigV2: Pick<
  Config,
  | 'appName'
  | 'acceptLanguage'
  | 'useBrandingOnAuth0'
  | 'useDnaV2Design'
  | 'restrictToNewUsers'
  | 'existingUserRedirectPath'
  | 'codePrefix'
  | 'steps'
  | 'fields'
  | 'isAccountCreationV2'
> = {
  appName: APPNAMES.BABYLON_US,
  acceptLanguage: 'en-US',
  useDnaV2Design: false,
  useBrandingOnAuth0: false,
  steps: [welcomeStep, aboutYouStep, summaryStep],
  isAccountCreationV2: true,
  fields: [
    [],
    [
      FIELDS.FIRST_NAME,
      FIELDS.LAST_NAME,
      FIELDS.DATE_OF_BIRTH_V2,
      FIELDS.ZIPCODE_V2,
      FIELDS.PHONE_COUNTRY_CODE,
      FIELDS.PHONE_NUMBER_V2,
    ],
  ],
}

const configWithFamilyPropsV2 = {
  ...premadeConfigV2,
  steps: [welcomeStep, aboutYouStep, familyStep, summaryStep],
  fields: [...premadeConfigV2.fields, familyMemberFields.USA],
}

const configWithFamilyAndEligibilityPropsV2 = {
  ...configWithFamilyPropsV2,
  steps: [welcomeStep, aboutYouStep, familyStep, eligibilityStep, summaryStep],
}

const configWithEligibilityPropsV2 = {
  ...premadeConfigV2,
  steps: [welcomeStep, aboutYouStep, eligibilityStep, summaryStep],
}

export {
  configWithFamilyPropsV2,
  configWithFamilyAndEligibilityPropsV2,
  configWithEligibilityPropsV2,
}
export default premadeConfigV2
